import {TokensData} from 'types';

enum StorageKeys {
    ACCESS_TOKEN = 'auth.token.access',
    REFRESH_TOKEN = 'auth.token.refresh',
    ACCESS_TOKEN_EXPIRES_IN = 'auth.token.accessExpiresIn',
    REFRESH_TOKEN_EXPIRES_IN = 'auth.token.refreshExpiresIn',
    SAVE_AUTH_DATA = 'auth.token.save',
}

export class TokenStorage {
    private static clearStorage(storage: Storage) {
        storage.removeItem(StorageKeys.ACCESS_TOKEN);
        storage.removeItem(StorageKeys.REFRESH_TOKEN);
        storage.removeItem(StorageKeys.ACCESS_TOKEN_EXPIRES_IN);
        storage.removeItem(StorageKeys.REFRESH_TOKEN_EXPIRES_IN);
        storage.removeItem(StorageKeys.SAVE_AUTH_DATA);
    }

    public static set keepTokens(value: boolean) {
        localStorage.setItem(StorageKeys.SAVE_AUTH_DATA, String(value));
    }

    public static get keepTokens(): boolean {
        const value = localStorage.getItem(StorageKeys.SAVE_AUTH_DATA);

        return value === 'true';
    }

    private static get storage(): Storage {
        return TokenStorage.keepTokens ? localStorage : sessionStorage;
    }

    public static removeTokens() {
        TokenStorage.clearStorage(sessionStorage);
        TokenStorage.clearStorage(localStorage);
    }

    public static storeTokens(tokensData: TokensData, saveCredentials = TokenStorage.keepTokens) {
        if (!saveCredentials) {
            TokenStorage.removeTokens();
        }

        localStorage.setItem(StorageKeys.SAVE_AUTH_DATA, String(saveCredentials));

        const {storage} = TokenStorage;
        storage.setItem(StorageKeys.ACCESS_TOKEN, tokensData.accessToken);
        storage.setItem(
            StorageKeys.ACCESS_TOKEN_EXPIRES_IN,
            tokensData.accessTokenExpiresIn.toISOString(),
        );
        storage.setItem(StorageKeys.REFRESH_TOKEN, tokensData.refreshToken);
        storage.setItem(
            StorageKeys.REFRESH_TOKEN_EXPIRES_IN,
            tokensData.refreshTokenExpiresIn.toISOString(),
        );
    }

    public static get accessToken(): string | null {
        return TokenStorage.storage.getItem(StorageKeys.ACCESS_TOKEN);
    }

    public static set accessToken(token: string | null) {
        const {storage} = TokenStorage;
        if (token) {
            storage.setItem(StorageKeys.ACCESS_TOKEN, token);
        } else {
            storage.removeItem(StorageKeys.ACCESS_TOKEN);
        }
    }

    public static get refreshToken(): string | null {
        return TokenStorage.storage.getItem(StorageKeys.REFRESH_TOKEN);
    }

    public static get accessTokenExpiresIn(): string | null {
        return TokenStorage.storage.getItem(StorageKeys.ACCESS_TOKEN_EXPIRES_IN);
    }

    public static get refreshTokenExpiresIn(): string | null {
        return TokenStorage.storage.getItem(StorageKeys.REFRESH_TOKEN_EXPIRES_IN);
    }
}
